import { refractor } from 'refractor';

// Cairo grammar modelled on Prism's Rust grammar. Cairo differs where it matters for
// highlighting: single quotes delimit short strings ('attacker' is a felt252), not chars or
// lifetimes; there are no block comments; and felt252/u256/ContractAddress & co. are core types.
function cairo(Prism: any) {
  const shortString = /'(?:\\[\s\S]|[^\\'\r\n])*'/;
  const byteArrayString = /"(?:\\[\s\S]|[^\\"])*"/;

  Prism.languages.cairo = {
    comment: {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: true,
      greedy: true,
    },
    string: {
      pattern: byteArrayString,
      greedy: true,
    },
    'short-string': {
      pattern: shortString,
      greedy: true,
      alias: 'string',
    },
    attribute: {
      pattern: /#\[(?:[^[\]"']|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'\r\n])*')*\]/,
      greedy: true,
      alias: 'attr-name',
      inside: {
        string: byteArrayString,
        'short-string': { pattern: shortString, alias: 'string' },
      },
    },
    // Closure params should not be confused with bitwise OR |
    'closure-params': {
      pattern: /([=(,:]\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
      lookbehind: true,
      greedy: true,
      inside: {
        'closure-punctuation': {
          pattern: /^\||\|$/,
          alias: 'punctuation',
        },
        rest: null, // see below
      },
    },
    'function-definition': {
      pattern: /(\bfn\s+)\w+/,
      lookbehind: true,
      alias: 'function',
    },
    'type-definition': {
      pattern: /(\b(?:enum|impl|struct|trait|type)\s+)\w+/,
      lookbehind: true,
      alias: 'class-name',
    },
    'module-declaration': {
      pattern: /(\bmod\s+)[a-z_]\w*/,
      lookbehind: true,
      alias: 'namespace',
    },
    keyword:
      /\b(?:Self|as|break|const|continue|crate|else|enum|extern|fn|for|if|impl|implicits|in|let|loop|match|mod|mut|nopanic|of|pub|ref|return|self|static|struct|super|trait|type|use|while)\b/,
    builtin:
      /\b(?:Array|ByteArray|Box|ClassHash|ContractAddress|EthAddress|Felt252Dict|NonZero|Nullable|Span|StorageAddress|bool|bytes31|felt252|i(?:8|16|32|64|128)|u(?:8|16|32|64|128|256|384|512)|usize)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
    macro: {
      pattern: /\b\w+!(?!=)/,
      alias: 'property',
    },
    constant: /\b[A-Z_][A-Z_\d]+\b/,
    'class-name': /\b[A-Z]\w*\b/,
    namespace: {
      pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
      inside: {
        punctuation: /::/,
      },
    },
    // Hex, oct, bin, dec numbers with visual separators and an optional type suffix (10_u8, 0x1_felt252)
    number:
      /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|\d(?:_?\d)*)(?:_?(?:felt252|i(?:8|16|32|64|128)|u(?:8|16|32|64|128|256)|usize))?\b/,
    punctuation: /->|=>|\.\.=?|::|[{}[\];(),:.]/,
    // `@` takes a snapshot, `*` desnaps, `?` propagates errors
    operator: /[-+*/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?~]/,
  };

  Prism.languages.cairo['closure-params'].inside.rest = Prism.languages.cairo;
}

cairo.displayName = 'cairo';
cairo.aliases = [] as string[];

if (!refractor.registered('cairo')) {
  refractor.register(cairo);
}
